module.exports = __webpack_public_path__ + "static/img/21.04cd13c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/21.png
// module id = G2MX
// module chunks = 35